import { DateTime } from "ionic-angular";

export class Event {
    id:number;
    eventname: string;
    eventstartdate: any;
    eventenddate: any;
    eventstarttime: any;
    eventendtime: any;
    deliveredby: string;
    eventdetails: string;
    sponsor: string; 
}


// WEBPACK FOOTER //
// ./src/models/Event.ts